<template>
    <div class="created">
        <!-- 新增/编辑 -->
        <el-dialog :title="List ? '编辑SKU' : '新建SKU'" :visible.sync="dialogVisible" width="70%" top="4vh" :before-close="beforeClose">
            <el-form ref="form" :rules="rules" :model="form" label-width="150px">
                <el-row type="flex" align="middle">
                    <div class="summary_complete_bag" v-if="form.salesType == '2'">
                        <div class="summary_complete">
                        <div style="border-radius: 4px 0 0 4px;" @click="complete(1)" v-bind:class="{ active: type === 1 }">
                            基本信息
                        </div>
                        <div style="border-radius: 0 4px 4px; 0" @click="complete(2)" v-bind:class="{ active: type === 2 }">
                            变体信息
                        </div>
                        </div>
                    </div>
                </el-row>

                <div class="Minister-top-top productbackground" v-if="type != 2">
                    <div class="Minister-top-left product-top-color">商品图片</div>
                </div>
                <el-form-item label="商品图片：" v-if="type != 2">
                    <div class="uploadPictures">
                        <draggable
                        class="list-group"
                        tag="ul"
                        @start="isDragging = true"
                        @end="isDragging = false"
                        :list="imgListSelect"
                        handle=".list-group-item"
                        >
                        <li
                            class="list-group-item"
                            v-for="(element, index) in imgListSelect"
                            :key="element.url+index"
                        >
                            <div class="mask">
                            <i
                                class="custom-icon el-icon-zoom-in"
                                @click="handlePictureCardPreview(element)"
                            ></i>
                            <i
                                class="custom-icon el-icon-delete"
                                @click="handleRemoveSelect(index)"
                            ></i>
                            </div>
                            <div class="badge">
                            <img :src="element.url" alt />
                            </div>
                        </li>
                        <li
                            @click="showImgDialog"
                            class="avatar-uploader"
                            slot="footer"
                        >
                            <i data-v-c660ac10 class="el-icon-plus"></i>
                        </li>
                        </draggable>
                    </div>
                </el-form-item>

                <div class="Minister-top-top informationbackground" v-if="type != 2">
                    <div class="Minister-top-left information-top-color">基本信息</div>
                </div>

                <el-form-item label="中文名:" v-if="type != 2" prop="chineseName">
                    <el-input v-model.trim="form.chineseName"></el-input>
                </el-form-item>
                <el-form-item label="英文名:" v-if="type != 2" prop="englishName">
                    <el-input v-model.trim="form.englishName"></el-input>
                </el-form-item>
                <el-form-item label="sku:" v-if="type != 2" prop="newSku">
                    <el-input v-model.trim="form.sku"></el-input>
                </el-form-item>
                <el-form-item label="spu:" v-if="type != 2" prop="newSpu">
                    <el-input v-model.trim="form.spu"></el-input>
                </el-form-item>
                 <el-form-item label="品牌:" v-if="type != 2" prop="brand">
                    <el-input v-model.trim="form.brand"></el-input>
                </el-form-item>
                <el-form-item label="中文品名:" v-if="type != 2" prop="chineseProductName">
                    <el-input v-model.trim="form.chineseProductName"></el-input>
                </el-form-item>
                <el-form-item label="英文品名:" v-if="type != 2" prop="englishProductName">
                    <el-input v-model.trim="form.englishProductName"></el-input>
                </el-form-item>
                
                <el-form-item label="净重:" v-if="type != 2" prop="netWeight">
                    <el-input v-model.trim="form.netWeight"></el-input>
                    <span>  克</span>
                </el-form-item>
                <el-form-item label="毛重:" v-if="type != 2" prop="grossWeight">
                    <el-input v-model.trim="form.grossWeight"></el-input>
                    <span>  克</span>
                </el-form-item>

                <el-form-item class="inputshort" label="长*宽*高(cm):" v-if="type != 2">
                    <el-input v-model.trim="form.length"></el-input> * 
                    <el-input v-model.trim="form.width"></el-input> * 
                    <el-input v-model.trim="form.height"></el-input>
                </el-form-item>



                <!-- <el-form-item label="商品英文描述：" v-if="type != 2">
                    <el-input type="textarea" :row="7" v-model.trim="form.englishDescription" class="custom-textarea"></el-input>
                </el-form-item> -->

                <el-form-item label="商品英文描述：" v-if="type != 2">
                    <!-- <el-input type="textarea" :row="7" v-model.trim="form.englishDescription" class="custom-textarea"></el-input> -->
                    <div class="editor-container">
                      <el-card>
                        <quill-editor
                          v-model="
                            form.englishDescription
                          "
                          :options="editorOption"
                          
                        ></quill-editor>
                        <el-row
                          type="flex"
                          justify="space-between"
                        >
                          <el-row type="flex">
                            <h4>注意事项：</h4>
                            <span style="color:red;">
                              如果有从其它页面复制过来的文字，请先全选中复制的内容，然后点击文本编辑器中第二个按钮清除字体样式
                            </span>
                          </el-row>
                          <div>
                            {{ form.englishDescription.length }}/2000
                          </div>
                        </el-row>
                      </el-card>
                    </div>
                </el-form-item>
            </el-form>


            <div v-if="type == 2">
              <div style="margin-bottom:10px">
                <el-button plain @click="addVariant">添加变体信息</el-button>
              </div>

              <div class="summary_content">
                <div class="summary_list">
                  <el-table 
                    :data="summarylist" 
                    style="width: 100%" 
                    element-loading-text="拼命加载中" 
                    border
                    :header-cell-style="iscenter"
                    stripe 
                    max-height="600px">
                    <el-table-column label="图片" width="200" align="center">
                      <template slot-scope="scope" v-if="scope.row.mainImageUrl">
                                <el-image style="width: 80px; height: 80px" :src="scope.row.mainImageUrl.split(',')[0]" fit="fill"
                                :preview-src-list="scope.row.mainImageUrl.split(',').concat(scope.row.attachedImageUrl.split(','))"
                                ></el-image>
                            </template>
                    </el-table-column>

                    <el-table-column prop="newSku" label="sku" align="center">
                    </el-table-column>
                    <el-table-column prop="color" label="颜色" align="center">
                    </el-table-column>
                    <el-table-column prop="size" label="尺寸" align="center">
                    </el-table-column>
                    <el-table-column prop="netWeight" label="净重(g)" align="center">
                    </el-table-column>
                    <el-table-column prop="grossWeight" label="毛重(g)" align="center">
                    </el-table-column>
                    <el-table-column label="长*宽*高(cm)" align="center">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.length }} * {{ scope.row.width }} * {{ scope.row.height }}
                        </div>
                      </template>
                    </el-table-column>
                    </el-table>        
                </div>
              </div>
            </div>

            


            <div slot="footer">
                <el-button @click="beforeClose">取 消</el-button>
                <el-button type="primary" :loading="createBtnLoading" @click="save('form')">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="选择图片" class="uploaderImgVariant" :visible.sync="dialogFormVisible" width="1000px"
        @close="variantSelectImgDialogClose">
        <!-- <el-alert title="变体图片最多选择9张" type="error" :closable="false"></el-alert> 取消限制-->
            <el-divider></el-divider>
            <ul class="select-img" v-if="imageData.length">
                <li class="option" v-for="(item, index) in imageData" :key="index" @click="changeVariantSelectImg(item, index)">
                <div class="img-mask" v-if="
                    variantCheckedImgUidList.some((key) => key === item)
                ">
                    <i class="el-icon-upload-success el-true-check">
                    {{ getVariantSelectImgIndex(item) }}
                    </i>
                </div>
                <img :src="item.url" alt />
                </li>
            </ul>
            <el-divider v-if="imageData.length"></el-divider>
            <!-- <el-upload class="custom-update" :action="action" accept="image/gif, image/jpeg, image/tiff, image/png, image/bpm" drag multiple
                :show-file-list="false" list-type="picture-card" :on-success="handleAvatarSuccess" :headers="customHeaders">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                <p>
                    图片可批量上传，只支持
                    <span style="color:red;font-weight:bold;">JPG/TIFF/JPEG/PNG/BPM</span>
                    格式图片，首选
                    <span style="color:red;font-weight:bold;">JPEG</span>
                    格式， 图片的最长边不应低于
                    <span style="color:red;font-weight:bold;">1600</span>
                    像素，最长边不得超过
                    <span style="color:red;font-weight:bold;">10,000</span>
                    像素，不能包含徽标或水印。商品必须是填满
                    <span style="color:red;font-weight:bold;">85%</span>
                    的图片,图片详细标准请参阅Amazon平台要求。
                </p>
                </div>
            </el-upload> -->
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveVariantSelectImg()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 预览图片 -->
        <el-dialog :visible.sync="ImageVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>

        <!-- 提交图片 -->
        <!-- <el-dialog title="已选图片" class="uploaderImgVariant" :visible.sync="isShowVariantImg" width="1000px">
            <div class="image-container">
                <div class="img-box" v-for="item in variantImages" :key="item.uid">
                <img :src="item.data" />
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="isShowVariantImg = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="isShowVariantImg = false">确 定</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>   


<script>

import draggable from 'vuedraggable'
import { ajaxGet, ajaxPost, Baseurl } from '../../../api/api/api'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
    name: 'EditSKU',
    components: {
        draggable,
        quillEditor,
    },
    data() {
        return {
            summarylist: [],
            type: 1,
            dialogVisible: false,
            List: {},
            createBtnLoading: false,
            form: {
                salesType: '2',
                sku: '',
                spu: '',
                chineseName: '',
                englishName: '',
                brand: '',
                netWeight: '',
                grossWeight: '',
                length: '',
                width: '',
                height: '',
                color: '',
                size: '',
                chineseProductName: '',
                englishProductName: '',
                englishDescription: '',

            },
            rules: {

            },
            imgListSelect: [],
            dialogFormVisible: false, //选择图片
            dialogVariantVisible: false,
            variantCheckedImgUidList: [],
            imageData: [],
            dialogImageUrl: [],  //预览图片
            ImageVisible: false,
            editorOption: {
              placeholder: '请输入...',
              modules: {
                toolbar: ['bold', 'clean'],
              },
            },
            iscenter: {
              textAlign: 'center',
              background: '#f8f8f8',
              color: '#232323',
            },
        }
    },
    methods: {
        init(row) {
            if(row){
                // console.log(row.id);
                this.editProduct(row)
            }
        },
        editProduct(row) {
            // console.log(id);
            this.form.sku = row.newSku
            this.form.spu = row.newSpu
            this.form.chineseName = row.chineseName
            this.form.englishName = row.englishName
            this.form.brand = row.brand
            this.form.netWeight = row.netWeight
            this.form.grossWeight = row.grossWeight
            this.form.length = row.length
            this.form.width = row.width
            this.form.height = row.height
            this.form.chineseProductName = row.chineseProductName
            this.form.englishProductName = row.englishProductName
            this.form.englishDescription = row.englishDescription
            this.summarylist = row.productTongTuoList
            this.dialogVisible = true

            const img = row.mainImageUrl.split(',').concat(row.attachedImageUrl.split(','))
            const imageList = img.map(item => ({
              url: item
            }))
            this.imgListSelect = JSON.parse(JSON.stringify(imageList))
            // console.log(this.imgListSelect);
        },
        beforeClose() {
            this.$confirm('关闭弹窗将无法保存相关数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // this.handleRadio('1')
                this.dialogVisible = false
            }).catch(() => {
                this.$message({
                type: 'info',
                message: '已取消关闭'
                });
            });
        },
        showImgDialog() {
            this.checkedIndex = -1
            this.dialogFormVisible = true
        },
        variantSelectImgDialogClose() {
            this.variantCheckedImgUidList = []
        },
        // handlePictureCardPreview(file) {
        //     this.dialogImageUrl = file.url;
        //     this.ImageVisible = true;
        // },
        handlePictureCardPreview(file) {
          let imageUrl = ''
          if (Object.prototype.toString.call(file) === '[object Object]') {
                    // console.log(file.url);
            imageUrl = file.url
          } else {
            imageUrl = file
          }
          this.dialogImageUrl = imageUrl
          this.ImageVisible = true
        },
         complete(index) {
          this.type = index
        },
        addVariant() {
          this.dialogVariantVisible = true
        },
        
    }
}
</script>


<style lang="scss" scoped>

    .xingwarp {
  position: relative;
  .xingxing {
    color: #F56C6C;
    position: absolute;
    left: -92px;
    top: 0;
  }
}
.morePlatform /deep/ .el-select {
  width: 100%;
}

.el-input {
  width: 430px;
}

/deep/ .el-textarea__inner {
  height: 200px;
}

.inputshort .el-input {
  width: 133px;
}

.Minister-top-top {
  width: 100%;
  height: 30px;
  margin-bottom: 20px;
  border-radius: 3px;

  .Minister-top-left {
    border-radius: 3px 0 0 3px;
    width: 80px;
    line-height: 30px;
    float: left;
    text-align: center;
    font-size: 16px;
    color: #fff;
  }

  .Minister-top-color {
    background: #39b54a;
  }

  .product-top-color {
    background: #f37b1d;
  }

  .information-top-color {
    background: #0081ff;
  }

  .Minister-top-right {
    width: 80px;
    line-height: 40px;
    float: right;
    font-size: 16px;
    text-align: center;
  }
}

.informationbackground {
  background: #bfe2f3;
}

.productbackground {
  background: #fde6d2;
}

.Ministerbackground {
  background: #d7f0dbff;
}

.summary_complete_bag {
  overflow: hidden;

  .summary_complete {
    overflow: hidden;
    margin-bottom: 20px;
    border-bottom: 1px #eee solid;

    div {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
      border: #2c8dff 1px solid;
      text-align: center;
      float: left;
      cursor: pointer;
    }

    .active {
      background: #2c8dff;
      color: #fff;
    }
  }
}

.rs-tab {
  width: 853px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
  padding: 10px 0;
  line-height: 25px;
}

.rs-tab li {
  display: inline-block;
}

.select-img {
  width: 100%;
  height: 320px;
  overflow: auto;

  .option {
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    float: left;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    position: relative;

    .img-mask {
      position: absolute;
      right: -17px;
      top: -7px;
      width: 46px;
      height: 26px;
      background: #13ce66;
      text-align: center;
      transform: rotate(45deg);

      .el-true-check {
        color: #fff;
        font-size: 12px;
        margin-top: 12px;
        transform: rotate(-45deg);
      }
    }

    img {
      width: 146px;
    }
  }
}

.custom-update {
  /deep/ .el-upload--picture-card {
    background: initial;
    border: initial;
    width: initial;
    height: initial;
    line-height: initial;
  }
}

.image-container {
  display: flex;
  flex-wrap: wrap;

  .img-box {
    width: 178px;
    height: 178px;
    margin-right: 10px;
    margin-bottom: 10px;
    border: 1px solid #eee;
    border-radius: 6px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.checked-img-container {
  width: 100%;
  height: 36px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 5px;

  .img-box {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    position: relative;
    margin-right: 10px;
    line-height: 28px;

    img {
      width: 100%;
      height: 100%;
      border: 1px solid #dcdfe6;
    }

    .el-icon-circle-close {
      display: none;
      position: absolute;
      right: -7px;
      top: -7px;
      color: #999;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
    }

    &:hover .el-icon-circle-close {
      display: block;
    }
  }
}

.list-group {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .list-group-item {
    width: 178px;
    height: 178px;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
    // float: left;
    position: relative;
    overflow: hidden;
    .mask {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      transition-duration: 0.5s;
      .custom-icon {
        font-size: 20px;
        margin: 0 8px;
        color: #fff;
      }
    }
    &:hover .mask {
      opacity: 1;
      border-color: #409eff;
    }
  }
  .list-group-item img {
    width: 100%;
    height: 100%;
  }
}
</style>

<style lang="scss" scoped>
.uploadPictures {
  /deep/ .el-upload-list__item {
    width: 178px;
    height: 178px;
  }
  /deep/ .el-upload--picture-card {
    width: 178px;
    height: 178px;
    line-height: 178px;
    padding: 0 20px;
  }
  /deep/ .selectUpload {
    // .el-upload.el-upload--picture-card,
    .el-upload-list__item-status-label {
      display: none;
    }
  }
  /deep/ .upload-demo {
    .el-upload-list--picture-card.el-upload-list {
      display: none;
    }
    .el-upload--picture-card {
      line-height: initial;

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }
  /deep/ .el-dialog__body {
    word-break: break-word;
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
  .list-group {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    .list-group-item {
      width: 178px;
      height: 178px;
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 10px;
      // float: left;
      position: relative;
      overflow: hidden;
      .mask {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transition-duration: 0.5s;
        .custom-icon {
          font-size: 20px;
          margin: 0 8px;
          color: #fff;
        }
      }
      &:hover .mask {
        opacity: 1;
        border-color: #409eff;
      }
    }
    .list-group-item img {
      width: 100%;
      height: 100%;
    }
  }
  .showImg {
    width: 148px;
    float: left;
    margin-right: 15px;
  }
  .avatar-uploader {
    width: 178px;
    height: 178px;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    text-align: center;
    line-height: 178px;
    font-size: 40px;
    &:hover {
      border-color: #409eff;
    }
  }
}
    
</style>